/**
 * NotFound — fallback for unregistered app routes.
 * Apr 23, 2026 (Agent 4): previously these routes rendered blank because
 * react-router silently matched nothing. Now they show a readable page
 * with a link home, and the user is never stuck on a white screen.
 */
import { Link, useLocation } from 'react-router-dom';
import { Home } from 'lucide-react';

export function NotFound() {
  const location = useLocation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="rounded-full bg-amber-50 p-4 text-amber-500">
        <Home size={28} />
      </div>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">
        Page not found
      </h1>
      <p className="mt-1 text-sm text-gray-500">
        We couldn't match a route for{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-700">
          {location.pathname}
        </code>
        .
      </p>
      <Link
        to="/dashboard"
        className="mt-5 inline-flex items-center gap-2 rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[var(--ink-1)]"
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
